import axios from 'axios';
import { createHashHistory } from 'history';
const history = createHashHistory();

/**
 * ajax 重定义ajax，为了ajax防重
 *
 * @param {Object} settings跟jquery ajax一样
 * @param {String} setting.guid 必填，唯一，判断防重的标准
 */

let no_error = true;
let ajax = function(settings) {

    // notSetOne 表示可以重复发送ajax请求
    if (ajax[settings.guid] && !settings.notSetOne) {
        return ajax[settings.guid];
    }

    let promise = new Promise((resolve, reject) => {

        let obj = {
            type: 'get',
            dataType: 'json',
            headers: {
                contentType: "application/json; charset=utf-8"
            }
        }
        // 默认get的请求 contentType = "application/json; charset=utf-8";
        // obj.headers['Content-Type'] = "application/json; charset=utf-8" : '';
        // 过滤undefined null的属性
        settings = Object.assign(obj, settings);
        settings.method = settings.type.toLowerCase();

        //console.log('settings.contentType', !settings.contentType, '3333', settings.contentType);
        // 判断是否设置了 contentType
        if (!settings.contentType) {
            let searchParams = new URLSearchParams();
            for (let name in settings.data) {
                searchParams.append(name, settings.data[name]);
            }
            settings.data = searchParams;
        } else {
            settings.headers['Content-Type'] = settings.contentType;
        }

        // 判断请求方式 get/post
        let request = '';

        switch (settings.type.toLowerCase()) {
        case 'post':
            request = axios(settings);
            break;
        case 'delete':
            request = axios.delete(settings.url, {
                params: settings.data
            })
            break;
        default:
            request = axios.get(settings.url, {
                params: settings.data
            });
            break;
        }

        request.then((axiosData) => {
            !settings.notSetOne &&
            delete ajax[settings.guid];
            let data = axiosData.data;
            // 返回的内容 code不等于0 并 或者status不成功
            // showError -》 当code不等于0的时候，是否默认弹出error框。默认是弹出，当showError为true时是不弹出
            //let responseURL = axiosData.request.responseURL;
            /*if (!settings.showError && (axiosData.status !== 200 || (data.code !== 0 && responseURL && responseURL.indexOf('c4a') < 0))) {

                no_error = false;
            }*/
            resolve(data);

        })
            .catch(function(error) {
            !settings.notSetOne && delete ajax[settings.guid];
            if (error.response.status === 500 && no_error) {
               if(settings.showError){
                   history.push("/systemerror");
               }
            }
            reject(error);

        })


    });

    ajax[settings.guid] = promise;
    return promise;
};

const get = function(setting) {
    return ajax(Object.assign({
        method: 'GET'
    }, setting))
}

let post = function(setting) {
    return ajax(Object.assign({
        method: 'POST'
    }, setting))
}

export default {
    get,
    post,
    ajax
};


// WEBPACK FOOTER //
// ./src/ajax/ajax.js